export default __webpack_public_path__ + "img/12ab32cfe234eca49e025e56851b4260.svg";